import { Subscription } from 'rxjs';
import { Identity } from './../../Identity';
import { EntitlementService } from './../../services/entitlement.service';
import { MerchantService } from './../../services/merchant.service';
import { Merchant } from './../../Merchant';
import {
  Injector,
  Injectable,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter
} from '@angular/core';
import { MessageService } from '../../services/message.service';
import { UserAuthInfoService } from '../../services/user-auth-info.service';
import { CardholderService } from '../../services/cardholder.service';
import { NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import {ShipService} from "../../services/ship.service";
import {ToastrService} from "ngx-toastr";

@Injectable()
export class MerchantsComponent implements OnInit, OnDestroy {
  public merchant: Merchant;
  public recentMerchants: Merchant[];
  public merchantAccountInfo: any = null;
  public identity: Identity;
  public merchantService: MerchantService;
  public entitlementService: EntitlementService;
  public processing = false;
  public messageService: MessageService;
  public cardHolderService: CardholderService;
  public userAuthInfoService: UserAuthInfoService;
  public calendar: NgbCalendar;
  public merchantSelectedSub: Subscription;
  public shipService: ShipService;
  public toastrService: ToastrService;

  @Output() merchantAccountInfoSet: EventEmitter<boolean> = new EventEmitter();

  constructor(injector: Injector) {
    this.merchantService = injector.get(MerchantService);
    this.entitlementService = injector.get(EntitlementService);
    this.messageService = injector.get(MessageService);
    this.cardHolderService = injector.get(CardholderService);
    this.userAuthInfoService = injector.get(UserAuthInfoService);
    this.calendar = injector.get(NgbCalendar);
    this.shipService = injector.get(ShipService);
    this.toastrService = injector.get(ToastrService);

    this.merchant = this.merchantService.getSelectedMerchant();
    this.recentMerchants = this.merchantService.getRecentMerchants();

    this.setMerchantAccountInfo(this.merchant);

    this.merchantSelectedSub = this.merchantService.merchantSelected.subscribe(
      (merchant: Merchant) => {
        this.merchantAccountInfo = null;
        this.merchant = merchant;
        this.setMerchantAccountInfo(merchant);
      }
    );
  }

  ngOnInit() {}

  ngOnDestroy() {
    this.merchantSelectedSub.unsubscribe();
  }

  public hasEntitlement(entitlement: string): boolean {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  setMerchantAccountInfo(merchant: Merchant) {
    if (this.merchant) {
      this.merchantService
        .getMerchantData(this.merchant.ncMerchantNum, this.merchant.location)
        .subscribe(data => {
          this.merchantAccountInfo = data;
          this.identity = data.identity;
          this.merchantAccountInfoSet.emit(true);
        });
    }
  }

  getMerchantAccount(merchant: Merchant) {
    return this.merchantService.getMerchantData(
      merchant.ncMerchantNum,
      merchant.location
    );
  }
}
